import ExhibitorTypeContainer from "../../../Component/Application/ExhibitorType/ExhibitorTypeContainer";

const ExhibitorTypePage = () => {
    return (

        <div className="page-body">
            <ExhibitorTypeContainer/>
        </div>
    );
};

export default ExhibitorTypePage;